var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.38 29.094 1.59 1.596 10.947-10.72-10.947-10.627-1.66 1.626 9.358 9.031z","fillRule":"evenodd"}));
}

ArrowRight.defaultProps = {"height":"40","viewBox":"0 0 40 40","width":"40"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
